import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutStopProgressQuickInfo extends Layout {
    sourceStop: DataSource;
    tableStopProgress: Table;
}
